export const environment = {
  production: true,
  title: 'Pagos Elota',
  descripcion: 'Pago en línea del impuesto predial del H. Ayuntamiento de Elota. Consulta tu adeudo con tu clave catastral y paga con tarjeta.',
  banorte: false,
  bajio: false,
  bbva: false,
  servicio: '',
  azteca: true,
  bbva_rosario: false,
  ente: "H. Ayuntamiento de Elota",
  administracion: "2024 - 2027",
  url_escudo: "../assets/elota/ESCUDO.png",
  url_administracion: "../assets/elota/logoadministracionelota.png",
  url_footer: "../assets/elota/logoadministracionelota.png",
  direcciones: [
    "Ave. Gabriel Leyva y Lic. Saúl Aguilar Pico",
    "C.P. 82700",
    "La Cruz, Elota, Sinaloa"
  ],
  telefonos: [
    "696-961-01-11",
    "696-961-02-42"
  ],
  emails: [
    "micompromisoeselota@elota.gob.mx"
  ],
  url_aviso: "http://elota.gob.mx/cms/informacion-historica/",
  url_webapi: "https://servidorprogramacion.ddns.net/PAGOS_SADMUN_ELOTA/api/",
  url_sitio: window.location.origin,
  url_rpt: 'https://servidorprogramacion.ddns.net/PAGOS_SADMUN_ELOTA/api/Ingresos/GetReciboPredial',
  // url_rpt: 'http://servidorsecomrpt.ddns.net:8081/api/Ingresos/GetReciboPredialElota',
  cve_municipio: "022",
  municipio: "ELOTA",
  firebase: {
    apiKey: "AIzaSyDaB2qhHBuHg1uJ-pyz_zcDetA8UWK99ko",
    authDomain: "pagoselota.firebaseapp.com",
    projectId: "pagoselota",
    storageBucket: "pagoselota.appspot.com",
    messagingSenderId: "841058130833",
    appId: "1:841058130833:web:9057b0fe4c3cfb3ff35830",
    measurementId: "G-M2KQGE0LC4"
  },
  leyenda_fundamento: "Ley de ingresos del municipio de Elota para el año 2017. Artículos 1,2,5,7,8,9. Ley de" +
    "Hacienda Municipal del Estado de Sinaloa vigente para el año 2017 Artículos 30 al 37 y 105" +
    "Capítulo II. Ley deCatastro del Estado de Sinaloa Artículos 13,14 23 al 26 y 32 al 34. Ley" +
    "de Gobierno Municipal del Estado de Sinaloa Artículo 59 Fracción III y IV.",
  leyenda_recibo: "EN CASO DE REQUERIR FACTURA ELECTRONICA, SOLICITARLO EN UN PLAZO NO MAYOR A 3 DIAS DESPUES DEL MES EN QUE REALIZO EL PAGO",
  id_express: "279",
  llave: "-v0ae1AtAelqxsjcG",
  img_ayuda_1: '../assets/elota/AyudaPago.png',
  img_ayuda_2: '../assets/elota/ubicareciboelota.jpg',
  img_ayuda_3: '../assets/elota/consultatuadeudo.jpg'
};
